/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../../../lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../app/nls/StringResources'
], function(_, PropertiesProviderAPI, APIFactory, stringResources) {

	class AlignPropertiesProvider {

		constructor(options) {
			this.content = options.content;
			this.dashboardApi = options.dashboardAPI;
			this._api = APIFactory.createAPI(this, [PropertiesProviderAPI]);

			// register self as a properties provider contributing align properties
			this.content.getFeature('Properties').registerProvider(this.getAPI());
			this._icons = options.features['Dashboard.Icons'];
			const featureChecker = this.dashboardApi && this.dashboardApi.getGlassCoreSvc('.FeatureChecker');
			this.isPropertiesV2Enabled = featureChecker && featureChecker.checkValue('dashboard', 'PropertiesV2', 'enabled');
		}

		getAPI() {
			return this._api;
		}

		destroy() {
			this.dashboardApi = null;
		}

		getPropertyLayoutList(){
			let sectionId;
			if (this.isPropertiesV2Enabled) {
				sectionId = 'positionAndStyle';
				return [{
					id: sectionId,
					type: 'Section',
					label: stringResources.get('sectionName_positionAndStyle'),
					position: 1
				},
				...this.getPropertyLayoutControlList('positionAndStyle')];
			} else {
				sectionId = 'layout';
				return [{
					id: 'general',
					type: 'Group',
					label: stringResources.get('tabName_general')
				}, {
					id: sectionId,
					type: 'Section',
					label: stringResources.get('sectionName_layout'),
					position: 2
				},
				...this.getPropertyLayoutControlList('general.layout')];
			}
		}

		getPropertyList() {
			return [];
		}

		reset() { }

		getPropertyLayoutControlList(sectionId) {
			const selectedContent = this.dashboardApi.getCanvas().getSelectedContentList();
			const isReadOnly = selectedContent.length <= 1;
			const alignAction = this.dashboardApi.getFeature('alignAction');
			let position;
			if (this.isPropertiesV2Enabled) {
				position = 4;
			} else {
				position = 1;
			}

			return [{
				id: 'alignWidget',
				editor: {
					sectionId: sectionId,
					readOnly: isReadOnly,
					position: position,
					uiControl: {
						type: 'IconPicker',
						label: stringResources.get('toolbarActionAlign'),
						items: [{
							name: 'left',
							label: stringResources.get('alignWidgetLeft'),
							value: this._icons.getIcon('align-left').id
						}, {
							name: 'center',
							label: stringResources.get('alignWidgetCenter'),
							value: this._icons.getIcon('align-horizontally').id
						}, {
							name: 'right',
							label: stringResources.get('alignWidgetRight'),
							value: this._icons.getIcon('align-right').id
						}, {
							name: 'top',
							label: stringResources.get('alignWidgetTop'),
							value: this._icons.getIcon('align-top').id
						}, {
							name: 'middle',
							label: stringResources.get('alignWidgetMiddle'),
							value: this._icons.getIcon('align-vertically').id
						}, {
							name: 'bottom',
							label: stringResources.get('alignWidgetBottom'),
							value: this._icons.getIcon('align-bottom').id
						}],
						onChange: (name, selection) => {
							alignAction.applyAction(_.map(selection, (entry) => {
								return _.extend(entry, {
									layoutIds: _.map(selectedContent, content => content.getId())
								});
							}));
						}
					}
				}
			}];
		}
	}

	return AlignPropertiesProvider;

});